// extracted by mini-css-extract-plugin
export default {"text_box":"styles_text_box__sVhT8"};